import {SearchDisplayContext, SearchSortOption} from 'common/report/util/search/types';

export enum ShareStatusFilter {
  Shared = `Shared with you`,
  Owner = `Created by you`,
}

export enum FilterType {
  CreatorEmail = `creator-email`,
  ShareStatus = `share-status`,
  Report = `report`,
}

export type SearchFilter = {
  [FilterType.CreatorEmail]?: string[];
  [FilterType.ShareStatus]?: ShareStatusFilter[];
  [FilterType.Report]?: SearchDisplayContext[];
};

export type BrowseQueryParams = {
  filter: SearchFilter;
  sort: SearchSortOption;
};

export enum BrowseMode {
  Add = `add`,
  Browse = `browse`,
  Discover = `discover`,
}
